@if (loading) {
  <div class="w-8 h-8 mx-auto border-4 border-blue-900 rounded-full border-r-transparent animate-spin"
    role="status"
  aria-hidden="true"></div>
  <ng-content></ng-content>
}
